const siteTitle = 'Fullfør bestillingen';

export default {
  mainTexts: {
    siteTitle: `${siteTitle}`,
    formTitle1: 'Fyll inn informasjonen din',
    formTitle2: 'Du betaler her',
    btnForm: 'Fortsett',
    btnForm2: 'Betal',
    priceText1: 'Betaling',
    priceText2: 'Total',
    footerTitle: 'Online betaling',
    footerText: 'Bekreft med kredittkortet ditt',
  },

  home: {
    placeholder: {
      firstName: 'Fornavn',
      lastName: 'Etternavn',
      email: 'E-postadresse',
      phone: 'Telefon',
      city: 'By',
      address: 'Adresse',
      zip: 'Postnummer',
      continue: 'Fortsette',
      name: 'Nome',
    },
    confirmPayment: 'Bekreft betaling',
    cardNumber: 'kortnummer',
    expirationDate: 'utløpsdato',
    name: 'fornavn',
    month: 'måned',
    year: 'år',
    cvv: 'CVV',
  },
  validation: {
    requireEmail: 'E-postadressen din er tom',
    validEmail: 'E-postadressen er ugyldig',
    requirePhone: 'Telefonen din er tom',
    minPhone: 'Telefonfeltet må være minst 10 tegn langt.',
    requireFirstName: 'Fornavn kreves.',
    validFirstName: 'Fornavnet er ugyldig.',
    requireLastName: 'Etternavn-feltet er obligatorisk.',
    validLastName: 'Etternavnfeltet er ikke gyldig.',
    requireCity: 'Il campo della città è richiesto.',
    validCity: 'Byfeltet er ugyldig.',
    requireAddress: 'Adressefeltet er obligatorisk.',
    validAddress: 'Adressefeltet er ugyldig.',
    requireZip: 'Postnummerfeltet er obligatorisk.',
    validZip: 'ZIP-feltet er ikke gyldig.',
    requireCard: 'Le champ du numéro de carte est obligatoire.',
    minCard: 'Ikke nok symboler.',
    validCard: 'Kortnummerfeltet er ugyldig.',
    requireMonth: 'Utløpsmånedsfeltet er påkrevd.',
    requireYear: 'Utløpsåret er obligatorisk.',
    requireName: 'Det kreves å fylle ut feltet som tilsvarer navnet.',
    validName: 'Navnefeltet er ikke gyldig.',
    requireCvv: 'CV-feltet er obligatorisk.',
    validCvv: 'CVV-feltet er ikke gyldig.',
    minFirstName: 'Fornavnfeltet må være minst tre tegn. ',
    minLastName: 'Etternavnsfeltet må være minst tre tegn.',
    minCity: 'Byfeltet må inneholde minst tre tegn.',
    minAddress: 'Adressefeltet må inneholde minst tre tegn.',
    minZip: 'Postnummerfeltet må inneholde minst 3 tegn.',
    minName: 'Navnefeltet må være minst tre tegn.',
    minCvv: 'Cvv-feltet må inneholde minst tre tegn.',
    specialFirstName: 'Fornavnfeltet må ikke inneholde spesialtegn',
    specialLastName: 'Etternavnet på feltet må ikke inneholde spesialtegn',
    specialName: 'Feltnavn må ikke inneholde spesialtegn',
    specialCity: 'Landets by må ikke inneholde spesialtegn',
  },
  mask: {
    phone: '+47 99 99 99 99',
    zip: '9999',
    creditCard: '9999 9999 9999 9999',
    cvv: '9999',
  },
  getInTouch: {
    title: 'FÅ KONTAKT',
    firstName: 'fornavn',
    lastName: 'Etternavn',
    email: 'e-post',
    msg: 'beskjed',
    send: 'send',
    alreadyRegistered: 'Du er allerede registrert',
    unsubscribeLink: 'avmeldingslenke',
    worktime: 'Call Center drift fra 10h til 17h',
    phone: 'Telefon: Sofia +359 2 437 4207',
  },
};
